import { useStaticQuery, graphql } from "gatsby";

export const useFileFile = () => {
  const { allFileFile } = useStaticQuery(graphql`
    query allFileFile {
      allFileFile(filter: {url: {ne: null}}) {
        edges {
          node {
            publicUrl
            drupal_id
          }
        }
      }
    }
  `);

  return allFileFile.edges;
};